import eventClient from '%evp_ticket_frontend/js/redux/currentEvent/service/EventClient';
import fetchEventSuccess from './fetchEventSuccess';
import fetchEventError from './fetchEventError';

function fetchEvent(data) {
    return (dispatch) => {
        if (data.slug) {
            return eventClient.getEventBySlug(data.slug)
                .then(
                    event => dispatch(fetchEventSuccess(event)),
                    error => dispatch(fetchEventError(error)),
                );
        }

        return new Promise(resolve => resolve(null));
    };
}

export default fetchEvent;
